<div class="row col-12">
  <div class="col-6 text-right">
    <p>{{ 'import_account_codes' | translate }}</p>
  </div>
  <div class="col-6">
    <fa-icon [icon]="['fas','spinner']" class="custom-size text-secondary" [spin]="true" *ngIf="isInProgress"></fa-icon>
    <fa-icon id="import-account-codes-success" [icon]="['fas', 'check']" class="text-success" *ngIf="isSuccessful && ! isInProgress"></fa-icon>
    <fa-icon [icon]="['fas', 'sync-alt']" (click)="retryHandler()" class="pointer mr-2 text-primary" id="import-account-codes-retry-action" *ngIf="! isSuccessful && ! isInProgress"></fa-icon>
    <small class="text-muted text-danger" id="import-account-codes-error-message" *ngIf="! isSuccessful && ! isInProgress">{{ error | translate }}</small>
    <accounting-systems-common-import-progress *ngIf="isInProgress" (event-progress)="onProgressEvent($event)" class="ml-2 d-inline-block" progress-id="connect_import_accounts"></accounting-systems-common-import-progress>
  </div>
</div>
